import React, {useEffect, useState} from "react";
import request from "../../../../../Services/API/Requests";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Avatar from "@material-ui/core/Avatar";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {red} from "@material-ui/core/colors";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(() => ({
    avatar: {
        backgroundColor: red[500],
    },
    dialogContent: {
        padding: "16px 24px"
    }
}));


const LikedList = ({open, onClose, feedId, entity}) => {
    const [likedList, setLikedList] = useState([]);
    const classes = useStyles();
    useEffect(() => {
        async function getLikedList() {
            try {
                if (!feedId) return;
                const response = await request({
                    url: `${entity}/read`,
                    data: {id: feedId}
                });
                const richedLikeList = (response.like || []).map(l => {
                   if(response.uniqueUsers && response.uniqueUsers.length) {
                       const richedUser = response.uniqueUsers.find(u => u._id === l);
                       return richedUser ? richedUser : {name: l, avatar: ''}
                   }
                   return {name: l, avatar: ''}
                });
                setLikedList(richedLikeList || [])
            } catch (e) {
                console.log('Get liked list error', e)
            }
        }

        getLikedList();
    }, [feedId]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"}>
            <DialogContent dividers classes={{dividers: classes.dialogContent}}>
                <List dense>
                    {likedList.map(item => (
                        <ListItem dense button>
                            <ListItemIcon>
                                <Avatar aria-label="recipe" className={classes.avatar}>
                                    {(item ? item.name : '').charAt(0).toUpperCase()}
                                </Avatar>
                            </ListItemIcon>
                            <ListItemText>
                                {item ? item.name : ''}
                            </ListItemText>
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button variant={"text"} color={"primary"} onClick={onClose}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default LikedList;